var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForwardIconBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7043 9L6.00007 4.25L7.23802 3L9.71392 5.5L13.1802 9L9.96151 12.25L7.23802 15L6.00007 13.75L10.7043 9Z",
    fill: "#1C75BC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForwardIconBlue);
export default __webpack_public_path__ + "static/media/forwardIconBlue.43bc1240a8351156f5105f54e1224669.svg";
export { ForwardRef as ReactComponent };